import React from "react";
import { IQuoteStepState, IQuoteStepComponentProps } from "../components/interfaces";
import { IRealTimeAutoResult, IPaymentChoice, ILOBApiClient, IPaths } from "../classes/Domain";
import Utilities from "../classes/Utilities";
import ButtonContinue from "../components/ButtonContinue";
import QuoteStepBase from '../components/QuoteStepBase'
import QuoteStep from "./QuoteStepLayout";
import { connect } from "react-redux";
import { IAppState } from "../state/interfaces";
import FullQuoteActions from "../state/fullQuoteActions";

interface IState extends IQuoteStepState {
    choiceSelected: boolean,
    issueChoice: boolean,
    issueLaterChoice: boolean,
    getAgentChoice: boolean;
}

interface IProps extends IQuoteStepComponentProps {
    quoteUid: string,
    paymentChoice: IPaymentChoice,
    selectedRate: IRealTimeAutoResult,
    lobApiClient: ILOBApiClient,
    PATHS: IPaths;
}

class Checkout extends QuoteStepBase<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            choiceSelected: false,
            issueChoice: false,
            issueLaterChoice: false,
            getAgentChoice: false
        };

        this.issueNow = this.issueNow.bind(this);
        this.onApiCallError = this.onApiCallError.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
    }

    onApiCallError() {
        this.setState({ ...this.state, choiceSelected: false, issueChoice: false });
    }

    issueNow() {
        this.setState({ choiceSelected: true, issueChoice: true }, () => {
            const selectedRate = { ...this.props.selectedRate, urlMemo: this.props.paymentChoice.urlMemo, quoteUid: this.props.quoteUid };
            this.props.lobApiClient.createtQuote(selectedRate)
                .then((response) => {
                    const quoteId = parseInt(response.data, 10);

                    this.props.lobApiClient.getQuote(quoteId)
                        .then((qResponse) => {
                            qResponse.data.rtrQuoteId = quoteId;
                            this.props.updateAppState({ quote: qResponse.data })
                                .then(() => this.setState({ choiceSelected: false }, () => this.props.history.replace(Utilities.formatUrl(this.props.PATHS.FQ_CARS /*PATHS.FQ_PAYMENT*/, ""))));
                        });
                },
                this.onApiCallError)
        });
    }

    issueLater() {

    }

    getAgent() {

    }

    render() {
        return (
            <QuoteStep id={this.props.id} className="checkout-choices">
                <div className="titleArea"><h5>Next Step</h5></div>

                <div className="choice">
                    {
                        //<p className="text-center">
                        //    If you want to issue immediately please click the "Issue Immediately" button below. You will need few things
                        //    handy like vehicle VINs and registrations and driver licenses for all drivers.
                        //</p>
                    }
                    <div className="text-center">
                        <ButtonContinue
                            disabled={this.state.choiceSelected}
                            showLoading={this.state.choiceSelected && this.state.issueChoice}
                            label="Buy Now"
                            onClick={this.issueNow} />

                       {/* <AuthorizeVerify />*/}
                    </div>
                </div>

                {
                    //<div className="choice">
                    //    <p className="text-center">
                    //        If you want to issue online but don't have all neccessary documents you can click on the button below and
                    //        we will email you the link to come later and finish the process.
                    //    </p>
                    //    <div className="text-center">
                    //        <ButtonContinue
                    //            disabled={this.state.choiceSelected}
                    //            showLoading={this.state.choiceSelected && this.state.issueLaterChoice}
                    //            label="Issue Later"
                    //            onClick={this.issueLater} />
                    //    </div>
                    //</div>
                }

                <div className="choice no-border">
                    <p className="text-center w-100 for-mobile">
                        To finish with an agent please click below to call us.
                    </p>
                    <p className="text-center w-100 for-desktop">
                        To finish with an agent please call us.
                    </p>
                    <div className="text-center">
                        <a href="tel:8883818050" className="btnContinue btn btn-primary btn-sm for-mobile">Call Us <i className="fas fa-phone"></i></a>
                        <span className="big-label text-center for-desktop">888-381-8050</span>
                        {
                            //ButtonContinue
                            //    disabled={this.state.choiceSelected}
                            //    showLoading={this.state.choiceSelected && this.state.getAgentChoice}
                            //    className="for-mobile"
                            //    label="Call Us"
                            //    onClick={this.getAgent} />
                        }

                        {/*<label className="for-desktop">For Desktop</label>*/}
                    </div>
                </div>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        quoteUid: state.quoteUid,
        selectedRate: state.rate,
        paymentChoice: state.paymentChoice,
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var fullQuoteActions = new FullQuoteActions(ownProps.lobApiClient);

    return {
        updateAppState: (update) => dispatch(fullQuoteActions.fillExternalQuote(update.quote))
    };
};

export default connect(mapProps, mapDispatch)(Checkout);
